import { Link } from "react-router-dom";
import AuthLayout from "../../layouts/AuthLayout";

export default function ForgotPassword() {
  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter your email and we’ll send reset instructions."
    >
      <form className="space-y-4">
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Email</span>
          <input
            type="email"
            placeholder="you@business.com"
            className="mt-1.5 w-full rounded-xl border border-slate-200 bg-slate-50 px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </label>

        <button className="w-full bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2.5 rounded-xl text-sm font-medium transition">
          Send Reset Link
        </button>
      </form>

      <p className="text-sm text-slate-500 text-center mt-6">
        Remembered your password?{" "}
        <Link to="/login" className="text-indigo-600 font-medium">
          Back to login
        </Link>
      </p>
    </AuthLayout>
  );
}
